module.exports = __webpack_public_path__ + "static/media/printing.3ec68d6f.jpeg";